import { UiError } from '../state';
import { ActionType, ApplicationAction } from './types';
import { patch } from './patch';

export const setError = (err: UiError): ApplicationAction => patch(
  { error: err }, ActionType.SetError
);
